import Cookies from 'js-cookie';
import {ACCESS_TOKEN, ACCESS_TOKEN_EXPIRY, GET, POST, showSnackbar} from '../Api';
import {API_AUTH_LOGOUT, API_AUTH_VALIDATE} from '../Constants';
import {localStorageSave} from '../Util/Utilities';

export const validateToken = (token: string) => {
  return POST(API_AUTH_VALIDATE, {token, access_token: true})
    .then(response => {
      if (response.status === 200) {
        Cookies.set('userid', response.data.userId, {expires: 7});
        const accessToken = response.data.access_token;
        const expiry = response.data.expiry;
        if (accessToken) {
          const expires = expiry ? new Date(expiry * 1000) : 7;
          Cookies.set(ACCESS_TOKEN, accessToken, {expires});
          localStorageSave(ACCESS_TOKEN, accessToken);
          if (expiry) localStorageSave(ACCESS_TOKEN_EXPIRY, expiry);
        }
        return {success: true};
      } else {
        return {success: false};
      }
    })
    .catch(() => showSnackbar('Sorry, you have enter an invalid email or password', 'error'));
};


export const logout = async () => {
  const res = await GET(API_AUTH_LOGOUT);
  return res.data.success;
};
